import { useState, useEffect, useRef, useCallback, Fragment, useMemo, useContext } from "react";
import style from "./MsgBoard.module.scss";
import { v4 } from "uuid";
import TabList from "../../comm/global/components/TabList";
import { Span } from "../../Styleds";
import ImageLoader from "../../comm/global/components/ImageLoader";
import apiManager from './../../ApiManager';
import AppConfig from './../../AppConfig';
import { GameContext } from "../../GameContext";
const MsgBoard = ({ eventVo, msgList, set_msgList, pinCb, participants }) => {
    const { userData } = useContext(GameContext);
    const [canEdit, set_canEdit] = useState(false);
    const [tabSelectId, set_tabSelectId] = useState(0);
    const [pinMsgIndex, set_pinMsgIndex] = useState(-1);
    const [msg, set_msg] = useState("");
    useEffect(() => {
        set_canEdit(participants.find(v => v.event_participants_user_detail.user_id === userData.users_id));
    }, [])
    return (
        <div className={style.app}>
            <div className={style.msgBoard}>
                <div className={style.msgList}>
                    {msgList.map((msgVo, k) => {
                        return <div className={style.item} key={k}>
                            <ImageLoader variant={"circular"} className={style.icon} src={msgVo.event_message_board_created_by_user.user_avatar} />
                            <div className={style.main}>
                                <div className={style.content}>
                                    <div className={style.name}>
                                        <Span size={12}>{msgVo.event_message_board_created_by_user.user_name}</Span>
                                    </div>
                                    <div className={style.txt}>
                                        <Span size={14} fontWeight={400}>{msgVo.event_message_board_base_message}</Span>
                                    </div>
                                    <div className={style.date}>
                                        <Span size={12}>{new Date(msgVo.event_message_board_created_at).toLocaleTimeString()}</Span>
                                    </div>
                                </div>
                                <div className={`${style.pinType} ${pinMsgIndex === k ? style.active : ""}`}>
                                    <div className={style.group}>
                                        <TabList selectId={tabSelectId} set_selectId={set_tabSelectId} list={AppConfig.announcementTags} ItemCls={PinItem} clear={false} />
                                    </div>
                                    <span onClick={e => {
                                        pinCb(AppConfig.announcementTags[tabSelectId], msgVo.event_message_board_base_message);
                                        set_pinMsgIndex(-1);
                                    }}>確認</span>
                                </div>
                            </div>
                            <img src={pinMsgIndex === k ? "./assets/ui/pinDark.png" : "./assets/ui/pin.png"} className={style.pinBtn} onClick={e => {
                                set_pinMsgIndex(k);
                            }} />
                        </div>
                    })}

                </div>
                {canEdit &&
                    <div className={style.ctrl}>
                        <input
                            type="text"
                            value={msg}
                            placeholder="來聊聊天吧"
                            onChange={(e) => {
                                if (e.target.value.length <= 100) {
                                    set_msg(e.target.value);
                                }
                            }}
                        />
                        <img src="./assets/ui/Send.svg" onClick={e => {
                            apiManager.fetchPost(`event/${eventVo.events_id}/message-board`, { event_message_board_base_message: msg }).then(res => {
                                res.event_message_board_created_by_user = userData
                                console.log(res);
                                set_msgList(prev => [...prev, res])
                            })
                            set_msg("");
                        }} />
                    </div>
                }

            </div>
        </div>
    );
}
const PinItem = ({ isSelect, data, index, onClick, selectId }) => {
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${style.item} ${style.selected}` : style.item}>
            <span>{data}</span>
        </div>
    );
}
export default MsgBoard;